import { render, staticRenderFns } from "./detail--form.vue?vue&type=template&id=a207fade&"
import script from "./detail--form.vue?vue&type=script&lang=js&"
export * from "./detail--form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports